import styled from "styled-components";

import { Icon } from "components/ui-deprecated";

export const PageNavigationItemIcon = styled(Icon)`
    margin-left: 0.5rem;
`;
